import React,{useState} from "react";
import "../../assets/styles/styleUser.css";
import LogoLogin from "../../assets/logos/log.jpg";
import Input from "../../components/input/input";
import Btn from "../../components/button/btnWithoutIcon";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { colors } from "../../assets/config/color";
import AuthService from "../../services/AuthServices";
function ResetPassword(props) {
    const [email, setEmail] = useState("");
    const [isloading,setIsloading]=useState(false);
    const usernamechange = (event) => {
        setEmail(event.target.value);
      };
      const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };
  const handleResetPassword = async (email) => {
    setIsloading(true);
    try {
      if (!email) {
         toast.error("Une adresse e-mail valide est requis.");
       
        return;
      }
      const Regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/; 
      if (!email.match(Regex)) {
       toast.error("Veuillez renseigner une adresse e-mail valide !");
        
          return ;
      } 
      const response = await  AuthService.resetPassword(email);
     
      if (response.message) {
         toast.success(response.message);
          setEmail('');
      }
      else {
        toast.error(response.error);
      }
    }
    catch (error) {
       toast.error("Une erreur s'est produite, veuillez verifier votre connexion et reessayez");
                
        }
    finally{
      setIsloading(false);
    }
  };
  return (
    <div className="containerR">
        <img src={LogoLogin} alt="" width={100} height={100} />
        <div>
          <h3 style={{color:colors.gold}}>Forgot password</h3>
          <form>
          <br/>
            <div>
              <label className="label" style={{color:'black'}}>Email</label>
            </div>
            <br/>
            <div>
            <Input
                placeholder={"adresse@mail.com"}
                onChange={(event) => usernamechange(event)}
                value={email}
              />
            </div> <br/>
            <Btn
                txtbtn={ isloading?'Loading ...':"Send"}
                bgcolor={"168, 102, 127"}
                bgopacity={isloading?0.5:1}
                txtcolor={"#fff"}
                action={()=>handleResetPassword(email)}
              />
              <br/>
              <div className="rowEnd" onClick={()=> handleNavigation('/')}>
                <span style={{color:'#09AA29',textDecoration:'underline'}}>Login ?</span>
              </div>
          </form>
        </div>
        
    </div>
  );
}

export default ResetPassword;
